import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { ADMIN } from "@/shared/resource/apis/endpoints";
import { ADMIN_INFORMATION } from "@/shared/resource/constants";
import { dateTime } from "@/shared/utills/date";

export const useAdminStore = defineStore("admin", {
  state: () => ({
    admins: {
      list: [],
      totalCount: 0,
      info: [...ADMIN_INFORMATION],
    },
    admin: null,
  }),

  actions: {
    async addAdmin(payload) {
      const response = await api.post(ADMIN.CREATE, payload);
      return response.data;
    },

    async deleteAdmin(id) {
      const response = await api.delete(ADMIN.DELETE(id));
      return response.data;
    },

    async fetchAdmins({ page = 1, limit = 10, filters = {} }) {
      this.resetAdminsData();

      const response = await api.get(ADMIN.LIST, {params: { page_no: page, limit, ...filters }});
      const data = response?.data?.data || [];

      const formattedEntities = data.map((admin) => ({
        uuid: admin.id,
        id: admin.admin_id,
        name: admin.name,
        createdAt: dateTime.formatDateTime(admin.created_at),
        phoneNumber: admin.phone_number,
        email: admin.email,
        role: admin.role,
        status: admin.is_active,
      }));

      this.setAdminsData(formattedEntities, response.data.total_entries || 0, response.data);
      return formattedEntities;
    },

    async getAdminDetails(adminID) {
      const response = await api.get(ADMIN.GET(adminID));
      this.admin = response.data?.data;
      return response.data;
    },

    resetAdminsData() {
      this.admins.list = [];
      this.admins.totalCount = 0;
    },
    
    async save(id, payload) {
      let response;
      if (id) {
        response = await this.updateAdmin(id, payload);
      } else {
        response = await this.addAdmin(payload);
      }
      return response;
    },

    setAdminsData(admins, totalAdmins, info) {
      this.admins.list = admins || [];
      this.admins.totalCount = totalAdmins || 0;
      if (info) {
        this.admins.info[0].count = info.total_count || 0;
        this.admins.info[1].count = info.total_admin || 0;
        this.admins.info[2].count = info.total_super_admin || 0;
      }
    },

    async updateAdmin(id, payload) {
      const response = await api.put(ADMIN.UPDATE(id), payload);
      return response.data;
    },
  },

  getters: {
    getAdmins: (state) => state.admins,
  },
});
